/**
 * Formats a number as GBP currency
 * @param value - The numeric value to format
 * @returns Formatted currency string (e.g., "£1,234.56")
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Formats a number as GBP currency without decimal places
 * @param value - The numeric value to format
 * @returns Formatted currency string without pennies (e.g., "£1,234")
 */
export function formatCurrencyWhole(value: number): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
